<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    田贝站<br>
站点介绍<br>
3、7号线田贝站位于翠竹路与田贝四路交汇处的路口下，车站周围建筑较为密集，东南侧为金钻豪园小区，东北侧为南方电网水贝基地，西北侧有一栋高层化工大厦，西南侧是翠北小学。7号线田贝站在3号线田贝站正下方。两站形成T型换乘关系。在车站C、F出入口附近有全国最大的珠宝交易批发市场，是名副其实的“珠宝基地”。车站出入口采用自然采光设计，既美观又环保。田贝站以温暖的橙色为基调，象征着“丰收”之感 。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:10	23:44	3号线	2分15-20秒	4分30秒<br>
双龙	06:05	23:29	3号线	2分15-20秒	4分30秒<br>
西丽湖	06:22	23:02	7号线	3分35秒	5分55秒<br>
太安	06:27	23:55	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:19	23:44	3号线	3分15秒	5分钟<br>
双龙	06:14	23:29	3号线	3分15秒	5分钟<br>
西丽湖	06:21	23:02	7号线	4分钟	5分55秒<br>
太安	06:26	23:55	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:19	00:44	3号线	3分15秒	5分钟<br>
双龙	06:14	00:29	3号线	3分15秒	5分钟<br>
西丽湖	06:22	00:02	7号线	4分钟	5分55秒<br>
太安	06:26	00:55	7号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
翠竹路东侧（南）、太宁路、翠竹公园、康宁医院、翠田工业区、罗湖区委宿舍<br><br>
B出入口:<br>
翠竹路东侧（北）、太宁路、太安路、百仕达花园、翠竹大厦、罗湖供电局<br><br>
C出入口:<br>
翠竹路西侧（北）、水贝一路、田贝四路北侧（东）、贝丽花园、阳光天地家园、化工大院、罗湖工区、深华丽园、金丽国际珠宝交易中心<br><br>
D出入口:<br>
翠竹路西侧（南）、深圳市翠北实验小学、翠珠小区、田贝三路、马古岭小区、华盐大厦、燃气小区、广东省深圳市盐务局、千叶莲临床心理专业门诊部<br><br>
E出入口:<br>
田贝四路（南）、深圳市翠北实验小学、贝丽南路、金丽国际珠宝交易中心<br><br>
F出入口:<br>
贝丽花园、阳光天地家园、贝丽北路、田贝四路（北）、深圳市水田小学、水田二街、水贝万山<br><br>
G出入口:<br>
翠竹路西侧、水贝一路、田贝四路（北）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 五方广场<br>
1路,320路，376路<br><br>
B出入口:<br>
公交站名： 田贝地铁站<br>
2路，40路,57路，59路,62路,83路,107路,203路,209路，242路，333路，376路，977路，N2路,N6路，M482路<br><br>
C出入口:<br>
公交站名： 翠北小学<br>
1路,209路,320路,333路,379路<br><br>
D出入口:<br>
公交站名： 田贝地铁站<br>
2路，40路,57路，59路,62路,83路,107路,203路,209路，242路，333路，376路，977路，N2路,N6路，M482路<br><br>
E出入口:<br>
公交站名： 翠北小学<br>
1路,209路,320路,333路,379路<br><br>
F出入口:<br>
公交站名： 翠北小学<br>
1路,209路,320路,333路,379路<br><br>
G出入口:<br>
公交站名： 翠北小学<br>
1路,209路,320路,333路,379路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>